import { render, staticRenderFns } from "./CommentsModal.vue?vue&type=template&id=6d406224&"
import script from "./CommentsModal.vue?vue&type=script&lang=js&"
export * from "./CommentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d406224')) {
      api.createRecord('6d406224', component.options)
    } else {
      api.reload('6d406224', component.options)
    }
    module.hot.accept("./CommentsModal.vue?vue&type=template&id=6d406224&", function () {
      api.rerender('6d406224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/modules/CommentsModal.vue"
export default component.exports